// PD-16688 — the Forms list (Forms → Forms and a storefront's Forms tab). The list is
// served in memory from GET /api/forms, so nothing on the server reads these ids: the
// page's query function reads the keyword and matches it against the rows it holds
// (formListQuery.ts in the list-builder utils).

import { createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

/** The filter the Forms list's search box writes to. */
export const FORM_LIST_KEYWORD_FILTER = 'formKeywords';

export const formFilters: FilterRegistry = {
	[FORM_LIST_KEYWORD_FILTER]: createKeywordFilter({
		label: 'Keywords',
		placeholder: 'Search forms...',
		objectTable: 'form',
		listKeys: ['forms'],
		fulltextFields: ['name', 'formKey', 'storefrontName'],
	}),
};
